export default "__VITE_ASSET__BkMkSnC4__"